import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

export const BudgetStatsCards = ({ stats }) => {
    if (!stats) return null;

    // Calculate savings rate
    const savingsRate = stats.total > 0 ? ((stats.total - stats.used) / stats.total * 100) : 0;

    return (
        <Row className="g-3 mb-4">
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Total Budget</h6>
                            <i className="ri-wallet-line fs-24 text-primary"></i>
                        </div>
                        <h2 className="card-value mb-1">${stats.total?.toFixed(2) || '0.00'}</h2>
                        <small className="d-block fs-sm">
                            Total allocated budget
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Used Amount</h6>
                            <i className="ri-shopping-cart-line fs-24 text-warning"></i>
                        </div>
                        <h2 className="card-value mb-1">${stats.used?.toFixed(2) || '0.00'}</h2>
                        <small className="d-block fs-sm">
                            Total spent amount
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Remaining</h6>
                            <i className="ri-coins-line fs-24 text-success"></i>
                        </div>
                        <h2 className="card-value mb-1">${stats.remaining?.toFixed(2) || '0.00'}</h2>
                        <small className="d-block fs-sm">
                            Available budget
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Savings Rate</h6>
                            <i className="ri-line-chart-line fs-24 text-info"></i>
                        </div>
                        <h2 className="card-value mb-1">{savingsRate.toFixed(1)}%</h2>
                        <small className="d-block fs-sm">
                            Monthly savings rate
                        </small>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}; 